<template>
  <div v-if="indicadores.length > 0 && mostrar">
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left mt-5 gilmer d-print-none"
      >INDICADORES DE LA AGENCIA DE LA CALIDAD</b-col
    >
    <div
      class="accordion mt-3 filtros d-print-none"
      id="indicadores"
      role="tablist"
    >
      <!-- SIMCE  -->
      <b-card no-body class="border-bottom" v-if="simce.length > 0">
        <b-card-header class="p-0 bg-morado-claro" id="heading2">
          <b-button
            class="btn-wrap w-100 text-left pb-1 pt-2"
            variant="outline"
            id="collapse-simce-desempenio"
            data-testid="collapse-simce-desempenio"
            v-b-toggle.simce-desempenio
            @click="
              $gtag.event('ver-simce', {
                event_category: 'indicadores-calidad',
                event_label: 'ver-simce',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="award"
                class="h5 text-center mr-1 fa-sm ml-2 mr-3"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >SIMCE</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="simce-desempenio"
          accordion="acordion-desempenio"
          role="tabpanel"
        >
          <b-card-body class="card-body py-2 px-3 text-dark">
            <div class="row">
              <div class="col" v-if="simceBasica">
                <table
                  class="table table-bordered text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-morado-oscuro bg-white text-left text-normal"
                        colspan="3"
                      >
                        Enseñanza Básica {{ anioCategoriaSimceBasica }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Prueba
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Puntaje
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Comparación con colegios del mismo GSE (*)
                      </td>
                    </tr>
                    <tr
                      v-if="
                        simceBasica.clasificaciones.find(data => {
                          return data.nombreIndicador === 'Lenguaje';
                        }).puntaje
                      "
                    >
                      <td class="bg-morado-claro text-morado-claro">
                        Lenguaje
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceBasica.clasificaciones.find(data => {
                            return data.nombreIndicador === "Lenguaje";
                          }).puntaje
                        }}
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceBasica.clasificaciones.find(data => {
                            return data.nombreIndicador === "Lenguaje";
                          }).comparacionGseGlosa
                        }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        simceBasica.clasificaciones.find(data => {
                          return data.nombreIndicador === 'Matemática';
                        }).puntaje
                      "
                    >
                      <td class="bg-morado-claro text-morado-claro">
                        Matemática
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceBasica.clasificaciones.find(data => {
                            return data.nombreIndicador === "Matemática";
                          }).puntaje
                        }}
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceBasica.clasificaciones.find(data => {
                            return data.nombreIndicador === "Matemática";
                          }).comparacionGseGlosa
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col" v-if="simceMedia">
                <table
                  class="table table-bordered text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-morado-oscuro text-left text-normal"
                        colspan="3"
                      >
                        Enseñanza Media {{ anioCategoriaSimceMedia }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Prueba
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Puntaje
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Comparación con colegios del mismo GSE (*)
                      </td>
                    </tr>
                    <tr
                      v-if="
                        simceMedia.clasificaciones.find(data => {
                          return data.nombreIndicador === 'Lenguaje';
                        }).puntaje
                      "
                    >
                      <td class="bg-morado-claro text-morado-claro">
                        Lenguaje
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceMedia.clasificaciones.find(data => {
                            return data.nombreIndicador === "Lenguaje";
                          }).puntaje
                        }}
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceMedia.clasificaciones.find(data => {
                            return data.nombreIndicador === "Lenguaje";
                          }).comparacionGseGlosa
                        }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        simceMedia.clasificaciones.find(data => {
                          return data.nombreIndicador === 'Matemática';
                        }).puntaje
                      "
                    >
                      <td class="bg-morado-claro text-morado-claro">
                        Matemática
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceMedia.clasificaciones.find(data => {
                            return data.nombreIndicador === "Matemática";
                          }).puntaje
                        }}
                      </td>
                      <td class="bg-morado-claro text-morado-claro">
                        {{
                          simceMedia.clasificaciones.find(data => {
                            return data.nombreIndicador === "Matemática";
                          }).comparacionGseGlosa
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- SIMCE  fin -->
      <!-- INDICADORES DE DESARROLLO PERSONAL Y SOCIAL  -->
      <b-card
        no-body
        class="mt-2 border-bottom"
        v-if="desarrolloPersonal.length > 0"
      >
        <b-card-header class="card-header p-0 bg-morado-claro" id="heading3">
          <b-button
            class="btn-wrap w-100 text-left pb-1 pt-2"
            variant="outline"
            id="desarrollo-desempenio"
            data-testid="desarrollo-desempenio"
            v-b-toggle.desarrollo-desempenio
            @click="
              $gtag.event('ver-desarrollo-personal', {
                event_category: 'indicadores-calidad',
                event_label: 'ver-desarrollo-personal',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="chart-bar"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong
                class="col-9 pl-2 border-left text-morado-claro d-inline-block"
                >Desarrollo personal y social</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="desarrollo-desempenio"
          accordion="acordion-desempenio"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro ">
            <span class="texto-pequeño"
              >Estos resultados entregan información sobre el aprendizaje de los
              estudiantes y su desarrollo en el área personal y social.</span
            >
            <div class="row">
              <div class="col" v-if="desarrolloPersonalBasica">
                <table
                  class="table table-bordered bg-morado-claro text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-morado-claro text-left bg-blanco text-normal"
                        colspan="3"
                      >
                        Enseñanza Básica {{ anioCategoriaDesarrolloBasica }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Indicador
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Puntaje
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Comparación con colegios del mismo GSE (*)
                      </td>
                    </tr>
                    <tr
                      v-for="(dp,
                      index) in desarrolloPersonalBasica.clasificaciones"
                      :key="'desarrollo-personal-basica-' + index"
                    >
                      <td class="text-morado-claro">
                        {{ dp.nombreIndicador }}
                      </td>
                      <td class="text-morado-claro">{{ dp.puntaje }}</td>
                      <td class="text-morado-claro">
                        {{
                          dp.comparacionGseGlosa +
                            " (" +
                            dp.comparacionGseNumero +
                            ")"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col" v-if="desarrolloPersonalMedia">
                <table
                  class="table table-bordered bg-morado-claro text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-morado-claro text-left bg-blanco text-normal"
                        colspan="3"
                      >
                        Enseñanza Media {{ anioCategoriaDesarrolloMedia }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Indicador
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Puntaje
                      </td>
                      <td class="bg-morado-oscuro text-white font-weight-bold">
                        Comparación con colegios del mismo GSE (*)
                      </td>
                    </tr>
                    <tr
                      v-for="(dp,
                      index) in desarrolloPersonalMedia.clasificaciones"
                      :key="'desarrollo-personal-media-' + index"
                    >
                      <td class="text-morado-claro">
                        {{ dp.nombreIndicador }}
                      </td>
                      <td class="text-morado-claro">{{ dp.puntaje }}</td>
                      <td class="text-morado-claro">
                        {{
                          dp.comparacionGseGlosa +
                            " (" +
                            dp.comparacionGseNumero +
                            ")"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="small text-morado-claro font-weight-bold">
              (*) Grupo Socioeconómico
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- INDICADORES DE DESARROLLO PERSONAL Y SOCIAL  fin -->
      <!-- CATEGORÍA DE DESEMPEÑO  -->
      <b-card
        no-body
        class="mt-2 border-bottom"
        v-if="
          categoriaDesempenio.length > 0 &&
            ((categoriaDesempenioBasica &&
              categoriaDesempenioBasica.titulo != 'Sin categoría') ||
              (categoriaDesempenioMedia &&
                categoriaDesempenioMedia.titulo != 'Sin categoría'))
        "
      >
        <b-card-header
          class="p-0 bg-morado-claro"
          id="categoria-desempenio-header"
          role="tab"
        >
          <b-button
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-desempenio"
            data-testid="collapse-desempenio"
            variant="outline"
            v-b-toggle.categoria-desempenio
            @click="
              $gtag.event('ver-categoria-desempeño', {
                event_category: 'indicadores-calidad',
                event_label: 'ver-categoria-desempeño',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="star"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Categoría de desempeño</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="categoria-desempenio"
          accordion="acordion-desempenio"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro h6">
            <p>
              La Categoría de Desempeño es el resultado de una evaluación
              integral que considera los niveles de aprendizaje de los
              estudiantes, los Indicadores de desarrollo personal y social, los
              resultados de las pruebas Simce y su progreso en las últimas
              mediciones.
            </p>
            <p>
              Estos resultados se ajustan según características como la
              vulnerabilidad de los estudiantes, para clasificar a los
              establecimientos en una de las cuatro categorías posibles: Alto,
              Medio, Medio-Bajo, Insuficiente.
            </p>
            <div class="row">
              <div
                class="col-12 col-lg"
                v-if="
                  categoriaDesempenioBasica &&
                    categoriaDesempenioBasica.titulo != 'Sin categoría'
                "
              >
                <table
                  class="table table-bordered text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th scope="col" class="text-morado-claro bg-morado-claro">
                        Enseñanza Básica {{ anioCategoriaDesempenioBasica }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioBasica.titulo === 'Alto'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        ALTO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioBasica.titulo === 'Medio'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        MEDIO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioBasica.titulo === 'Medio bajo'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        MEDIO-BAJO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioBasica.titulo === 'Insuficiente'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        INSUFICIENTE
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="text-morado-claro">
                  Esta categoría agrupa a establecimientos cuyos estudiantes
                  obtienen resultados
                  <strong>{{ categoriaDesempenioBasica.descripcion }}</strong
                  >, considerando siempre el contexto social de los estudiantes.
                </div>
              </div>

              <div
                class="col-12 col-lg"
                v-if="
                  categoriaDesempenioMedia &&
                    categoriaDesempenioMedia.titulo !== 'Sin categorí­a'
                "
              >
                <table
                  class="table table-bordered text-morado-claro my-2 text-center"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        class="text-morado-claro border-top-0 bg-morado-claro"
                      >
                        Enseñanza Media {{ anioCategoriaDesempenioMedia }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioMedia.titulo === 'Alto'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        ALTO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioMedia.titulo === 'Medio'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        MEDIO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioMedia.titulo === 'Medio bajo'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        MEDIO-BAJO
                      </td>
                    </tr>
                    <tr>
                      <td
                        :class="
                          categoriaDesempenioMedia.titulo === 'Insuficiente'
                            ? 'bg-morado-oscuro text-white'
                            : 'bg-morado-claro text-morado-claro'
                        "
                      >
                        INSUFICIENTE
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="text-morado-claro">
                  Esta categoría agrupa a establecimientos cuyos estudiantes
                  obtienen resultados
                  <strong>{{ categoriaDesempenioMedia.descripcion }}</strong
                  >, considerando siempre el contexto social de los estudiantes.
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- CATEGORÍA DE DESEMPEÑO  fin -->
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faStar,
  faAngleDown,
  faAward,
  faChartBar
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faStar, faAngleDown, faAward, faChartBar);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    indicadores: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      anioCategoriaDesempenioBasica:
        localStorage.getItem("anioIndicadorCatDesempenioBasica") ||
        "default value",
      anioCategoriaDesempenioMedia:
        localStorage.getItem("anioIndicadorCatDesempenioMedia") ||
        "default value",
      anioCategoriaSimceBasica:
        localStorage.getItem("anioIndicadorCatSimceBasica") || "default value",
      anioCategoriaSimceMedia:
        localStorage.getItem("anioIndicadorCatSimceMedia") || "default value",
      anioCategoriaDesarrolloBasica:
        localStorage.getItem("anioIndicadorCatDesarrolloBasica") ||
        "default value",
      anioCategoriaDesarrolloMedia:
        localStorage.getItem("anioIndicadorCatDesarrolloMedia") ||
        "default value"
    };
  },
  computed: {
    mostrar() {
      return (
        this.indicadores.filter(i => i.titulo != "Sin categoría").length > 0
      );
    },
    //obtiene indicadores de categoria desempeño
    categoriaDesempenio() {
      return this.indicadores.filter(data => {
        return data.tipo === "CATEGORIA_DESEMPENIO";
      });
    },
    //obtiene indicadores de categoria desempeño para E. Basica
    categoriaDesempenioBasica() {
      return this.indicadores.find(data => {
        return data.tipo === "CATEGORIA_DESEMPENIO" && data.nivel === "Básica";
      });
    },
    //obtiene indicadores de categoria desempeño para E. Media
    categoriaDesempenioMedia() {
      return this.indicadores.find(data => {
        return data.tipo === "CATEGORIA_DESEMPENIO" && data.nivel === "Media";
      });
    },
    //obtiene indicadores de desarrollo personal
    desarrolloPersonal() {
      return this.indicadores.filter(data => {
        return data.tipo === "DESARROLLO_PERSONAL";
      });
    },
    //obtiene indicadores de desarrollo personal para E. Basica
    desarrolloPersonalBasica() {
      return this.indicadores.find(data => {
        return data.tipo === "DESARROLLO_PERSONAL" && data.nivel === "Básica";
      });
    },
    //obtiene indicadores de desarrollo personal para E. Media
    desarrolloPersonalMedia() {
      return this.indicadores.find(data => {
        return data.tipo === "DESARROLLO_PERSONAL" && data.nivel === "Media";
      });
    },
    //obtiene indicadores de simce
    simce() {
      return this.indicadores.filter(data => {
        return data.tipo === "SIMCE";
      });
    },
    //obtiene indicadores de simce para E. Basica
    simceBasica() {
      return this.indicadores.find(data => {
        return data.tipo === "SIMCE" && data.nivel === "Básica";
      });
    },
    //obtiene indicadores de simce para E. Media
    simceMedia() {
      return this.indicadores.find(data => {
        return data.tipo === "SIMCE" && data.nivel === "Media";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/IndicadoresCalidad.vue